import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import {AppService} from '../app.service';
import {Skuska} from '../model/skuska';
import {TerminDetail} from '../model/TerminDetail';
import {Student} from '../model/Student';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-termin-detail',
    templateUrl: './termin-detail.component.html',
    styleUrls: ['./termin-detail.component.css'],
    standalone: false
})
export class TerminDetailComponent implements OnInit {

  loading = true;
  termin: Skuska;
  terminDetail: TerminDetail;
  nezverejneniCout = 0;
  studenti: Student[] = [];

  constructor(
    public dialogRef: MatDialogRef<TerminDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {termin: Skuska},
    private http: HttpClient,
    private appService: AppService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void
  {
    this.termin = this.data.termin;

    this.http.get<TerminDetail>(
      '/ais/rest/portal/student-predmety/termin-detail/' + this.data.termin.id
    )
      .subscribe({
        next: (data) => {
          this.terminDetail = data;
          if (this.terminDetail.studenti) {
            this.terminDetail.studenti.forEach((s) => {
              if (s.plneMeno === 'unknown') {
                this.nezverejneniCout++;
              } else {
                this.studenti.push(s);
              }
            });
          }
          this.loading = false;
        },
        error: (error) => {
          this.appService.openErrorDialog(error.error.message);
        }
      });
  }

    prihlasit() {
      this.appService.prihlasit(this.termin);
    }

    getTitulok() {
      return this.translateService.instant('Termín hodnotenia');
    }

    protected odhlasit() {
        this.appService.odhlasit(this.termin);
    }
}
